export default _theme => ({
  popover: {
    width: '70%'
  }
})
